import { Component } from "react";
import { IoEyeOutline } from "react-icons/io5";
import { MdInfoOutline } from "react-icons/md";
import { IoEyeOffOutline } from "react-icons/io5";
import { BsDot } from "react-icons/bs";
import SetMpin from "./SetMpin";

class SetPassWord extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value1: "",
      value2: "",
      continueBtn: false,
      openMpin: false,
      password: "",
      showPassword: false,
      email: props.studentDetails?.email,
      mobileNumber: props.studentDetails?.mobileNumber,
      name: props.studentDetails?.name,
      addmissionNumber: props.studentDetails?.addmissionNumber,
      showPass: false,
      showOpts: false,
    };

    this.handleChange1 = (event) => {
      this.setState({
        value1: event.target.value,
      });
    };

    this.handleChange2 = (event) => {
      this.setState({
        value2: event.target.value,
      });
    };
  }


  render() {
    const handlePassShowToggler = () => {
      this.setState({
        showOpts: !this.state.showOpts,
      });
    };

    let colour1 = "#666666",
      colour2 = "#666666",
      colour3 = "#666666",
      colour4 = "#666666",
      colour5 = "#666666",
      colour6 = "#666666",
      colour7 = false;

    if (this.state.value1.length >= "8") {
      colour1 = "#45BF55";
    }
    if (this.state.value1.match(/[A-Z]/)) {
      colour2 = "#45BF55";
    }
    if (this.state.value1.match(/[a-z]/)) {
      colour3 = "#45BF55";
    }
    if (this.state.value1.match(/[-’/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\]/)) {
      colour4 = "#45BF55";
    }
    if (this.state.value1 === this.state.value2 && this.state.value1 !== "") {
      colour5 = "#45BF55";
    }
    if (this.state.value1.match(/[0-9]/)) {
      colour6 = "#45BF55";
    }

    if (
      this.state.value1 === this.state.value2 &&
      this.state.value1 !== "" &&
      this.state.value2.match(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-’\/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\])[A-Za-z\d\-’\/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\]{8,}$/
      )
    ) {
      colour7 = true;
    }


    function myFunction() {
      var x = document.getElementById('myId1')
      var y = document.getElementById('close_eye')
      var Z = document.getElementById('open_eye')


      if (x.type === 'password') {
        x.type = 'text';
        y.style.display = 'none';
        Z.style.direction = 'block';
      }
      else {
        x.type = 'password';
        y.style.display = 'block';
        Z.style.direction = 'none';
      }
    }

    function myFunction2() {
      var x = document.getElementById('myId2')
      var y = document.getElementById('close_eye2')
      var Z = document.getElementById('open_eye2')


      if (x.type === 'password') {
        x.type = 'text';
        y.style.display = 'none';
        Z.style.direction = 'block';
      }
      else {
        x.type = 'password';
        y.style.display = 'block';
        Z.style.direction = 'none';
      }
    }

    const handeleTrue1 = () => {
      const password = this.state?.value1;
      const passwordConfirm = this.state?.value2;

      if (
        password === passwordConfirm &&
        passwordConfirm.match(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-’\/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\])[A-Za-z\d\-’\/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\]{8,}$/
        )
      ) {
        this.setState({ openMpin: true });
        this.setState({
          password: this.state?.value2,
        });
      }
    };

    return (
      <div>
        {!this.state.openMpin && (
          <div className="ContainerRegister h-100">
            <div className="row">
              <div className="col-md-3 p-0 bannerContainer">
                <img
                  className="bannerImg"
                  alt="icon"
                  src="/LoginRegister/BannerImg.png"
                ></img>
              </div>
              <div className="col-md-9 RegisterDetailContainer">
                <form>
                  <div className="InsideDetailCpntainer">
                    <div className="d-flex justify-content-center">
                      <img
                        className="registrationIcon"
                        src="/StudentImg/BreathSchoolLogo.png"
                        alt="icon"
                      />
                    </div>
                    <div className="d-flex justify-content-center headerRegistration mt-3">
                      Set Password
                    </div>

                    <div className="d-flex justify-content-between p-3 align-items-center registrationInput  mt-4">
                      <input
                        id="myId1"
                        type="Password"
                        required
                        name="Password"
                        maxLength={64}
                        className="otpInput"
                        placeholder="Set Password"
                        value={this.state.value1}
                        onChange={this.handleChange1}
                        autocomplete="off"
                      />
                      <span onClick={myFunction} className="Eye_login">
                        <IoEyeOutline id='open_eye' />
                        <IoEyeOffOutline id='close_eye' />
                      </span>
                    </div>
                    <div className="d-flex justify-content-between p-3 align-items-center registrationInput  mt-4">
                      <input
                        id="myId2"
                        type="Password"
                        className="otpInput"
                        name="confirm Password"
                        maxLength={64}
                        placeholder="Confirm Password"
                        value={this.state?.value2}
                        onChange={this.handleChange2}
                        autocomplete="off"
                      />
                      <span onClick={myFunction2} className="Eye_login">
                        <IoEyeOutline id="open_eye2" />
                        <IoEyeOffOutline id="close_eye2" />
                      </span>
                    </div>

                    {/* <div className="d-flex align-items-center mt-2 gap-1">
                      <span onClick={myFunction2} className="Eye_login">
                        <IoEyeOutline id="open_eye2" />
                        <IoEyeOffOutline id="close_eye2" />
                      </span>
                      <p style={{ margin: "0" }}>
                        {this.state.showPass
                          ? "Hide Password"
                          : "Show Password"}
                      </p>
                    </div> */}
                    {(this.state.value1 || this.state.showOpts) && (
                      <div className="mt-3">
                        <div className="error_msg_password">
                          <div>
                            <div className="flex items-center" style={{ color: colour1, fontSize: "12px" }}>
                              {" "}
                              <BsDot /> <span>minimum 8 characters&nbsp;</span>
                            </div>
                            <div className="flex items-center" style={{ color: colour4, fontSize: "12px" }}>
                              <BsDot /> <span>one special character</span>
                            </div>
                            <div className="flex items-center" style={{ color: colour6, fontSize: "12px" }}>
                              <BsDot /> <span>one number</span>
                            </div>
                          </div>
                          <div>
                            <div className="flex items-center" style={{ color: colour2, fontSize: "12px" }}>
                              {" "}
                              <BsDot /> <span>one uppercase letter</span>
                            </div>
                            <div className="flex items-center" style={{ color: colour3, fontSize: "12px" }}>
                              <BsDot /> <span>one lowercase letter</span>
                            </div>
                          </div>
                        </div>

                        <div className="flex items-center" style={{ color: colour5, fontSize: "12px" }}>
                          <BsDot /> <span>Password & Confirm Password Match</span>
                        </div>
                      </div>
                    )}
                    <div className="d-flex justify-content-center mt-4">
                      <button
                        type="submit"
                        className="RegisterBtn2"
                        disabled={!colour7}
                        onClick={handeleTrue1}
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
        {this.state.openMpin && (
          <SetMpin
            studentAuthDetails={this.state}
            setRegister={this.props.setRegister || (() => { })}
            setIsInProgress={this.props.setIsInProgress || (() => { })}
          />
        )}
      </div>
    );
  }
}
export default SetPassWord;
